import { fetchApi } from '@/config/axiosSetting';
import {
  WagesListParamsType,
  WagesListResponseType,
} from '@/modules/adjusterReportModules/IncidentParticipants/queries/getWagesList/getWagesListQuery.type';

export const wagesListQueryFunction = (
  params: WagesListParamsType,
): Promise<WagesListResponseType> =>
  fetchApi.get(
    `property/reports/${params?.id}/accident_users/damaged/adjusting/wages/list/`,
    { params },
  );
